import React, { useCallback, useEffect } from 'react';
import { traverse } from '@atlaskit/adf-utils/traverse';
import { Box, xcss } from '@atlaskit/primitives';
import { Message, MessageList } from '@atlassian/help-center-conversation';
import {
    useActions,
    useConversationId,
    useVirtualAgentMessages,
    useConversationProvider,
} from '../../controllers/conversation-store';
import { Input } from './input/index';

const getADFContent = (value: string) => {
    try {
        const data: string[] = [];
        traverse(JSON.parse(value), {
            text: ({ text = '' }) => {
                if (text.length > 0) data.push(text);
            },
        });

        return data.join(' ');
    } catch (_) {
        return value;
    }
};

export const Conversation = () => {
    const [conversationProvider] = useConversationProvider();

    const { addVirtualAgentMessage, setVirtualAgentLoading, setConversationId } = useActions();

    useEffect(() => {
        conversationProvider
            .startConversation()
            .then((response) => {
                setConversationId(response.id);
            })
            .catch((error) => {
                // todo handle error
                error;
            });
    }, [conversationProvider, setConversationId]);

    const [conversationId] = useConversationId();
    const [messages] = useVirtualAgentMessages();

    const handleSendMessage = useCallback(
        async (message: string) => {
            if (!conversationId) {
                // todo throw error
                return;
            }
            setVirtualAgentLoading(true);

            // add user message
            addVirtualAgentMessage({
                id: '123', // TODO what should this be?
                conversationChannelId: conversationId || '',
                content: message,
                createdAt: new Date().toDateString(),
                type: 'User',
            });

            // Send message to backend and add responses
            const response = await conversationProvider.sendMessage(message, conversationId);
            response.map((agentMessage) => addVirtualAgentMessage(agentMessage));

            setVirtualAgentLoading(false);
        },
        [addVirtualAgentMessage, conversationId, setVirtualAgentLoading, conversationProvider]
    );

    return (
        <Box xcss={containerStyles}>
            <Box xcss={messagesListStyles}>
                <MessageList>
                    {messages?.map((message) => (
                        <Message
                            key={message.id}
                            backgroundColor={message.type === 'User' ? 'grey' : undefined}
                            content={
                                message.type === 'Agent' ? getADFContent(message.message.content) : message.content
                            }
                            position={message.type === 'User' ? 'right' : 'left'}
                            borderColor={message.type === 'Agent' ? 'grey' : undefined}
                        />
                    ))}
                </MessageList>
                <Input onSubmit={handleSendMessage} />
            </Box>
        </Box>
    );
};

const containerStyles = xcss({
    height: '100%',
    '@media (min-width: 30rem)': {
        width: '80vw',
    },

    '@media (min-width: 64rem)': {
        width: '60vw',
    },
});

const messagesListStyles = xcss({
    maxHeight: `calc(100vh - 200px)`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
});
